import { useEffect, useState } from "react";
import { LinearProgress } from "@mui/material";
import ViewerEvents from "events/ViewerEvents";

export default function ProgressBar(props: { height?: number }) {
    const [isBusy, setIsBusy] = useState(false);
    var { height } = props;
    useEffect(() => {
        var setBusy = (status: any) => {
            setIsBusy(status.isBusy);
        };
        ViewerEvents.on("busy", setBusy);
        return () => {
            ViewerEvents.removeEventListener("busy", setBusy);
        };
    });
    if (typeof height === "undefined") {
        height = 2;
    }

    return (
        <div>
            {isBusy ? (
                <LinearProgress
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: 10000,
                        height: height,
                    }}
                ></LinearProgress>
            ) : (
                ""
            )}
        </div>
    );
}
